// @ts-nocheck
const app = require('./main')

if (module.hot) {
  module.hot.accept()
}



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 90
// module chunks = 0